import { CommonModule, LowerCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { DataDisplayModule } from '../data-display/data-display.module';
import { LoadingStripesModule } from '../loading-stripes/loading-stripes.module';
import { ProgressSpinnerModule } from '../progress-spinner/progress-spinner.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { SystemOverviewTableModule } from '../system-overview-table/system-overview-table.module';
import { TimeSelectorModule } from '../time-selector/time-selector.module';
import { NavigationMenuComponent } from './navigation-menu.component';
import { NavigationMenuService } from './navigation-menu.service';
import { SideNavService } from './side-nav.service';
import { StorageMetadataDialogComponent } from './storage-metadata-dialog/storage-metadata-dialog.component';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  DateFormattingService,
  LevelNameTranslationPipe,
  StorageLevelToCustomerLevelNamePipe,
  SystemMetadataService,
  TimezoneAwareDatePipe,
} from '@twaice-fe/frontend/shared/services';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { FeatureToggleModule } from 'ngx-feature-toggle';
import { TimezoneIndicatorComponent } from './timezone-indicator/timezone-indicator.component';

const ANGULAR_MATERIAL_MODULES = [MatMenuModule, MatSidenavModule];

const NG_ZORRO_MODULES = [
  NzDropDownModule,
  NzAutocompleteModule,
  NzInputModule,
  NzSpinModule,
  NzTooltipDirective,
  NzPopoverModule,
  NzModalModule,
  NzButtonModule,
  NzDividerModule,
];

const INTERNAL_MODULES = [
  SvgIconModule,
  DataDisplayModule,
  LoadingStripesModule,
  ProgressSpinnerModule,
  SystemOverviewTableModule,
  TimeSelectorModule,
  FormsModule,
  TimezoneAwareDatePipe,
];

const DECLARATIONS = [NavigationMenuComponent, StorageMetadataDialogComponent];

@NgModule({
  declarations: [...DECLARATIONS],
  imports: [
    CommonModule,
    FeatureToggleModule,
    ...INTERNAL_MODULES,
    ...ANGULAR_MATERIAL_MODULES,
    ...NG_ZORRO_MODULES,
    LevelNameTranslationPipe,
    StorageLevelToCustomerLevelNamePipe,
    LowerCasePipe,
    TimezoneIndicatorComponent,
  ],
  exports: [...DECLARATIONS],
  providers: [SideNavService, SystemMetadataService, DateFormattingService, NavigationMenuService],
})
export class NavigationMenuModule {}
